import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_INTEREST_EXTEND: MijnRoute = {
    path: 'rente/regulier-verlengen',
    navigationEvent: 'toRenteRegulierVerlengen',
    regex: /^\/hypotheek\/rente\/regulier-verlengen$/,
    webcomponent: 'mijn-hypotheken-renteverlenging-webcomponent',
    internalPath: 'regulier-verlengen'
};
